import { render, staticRenderFns } from "./investPlantCalculator.vue?vue&type=template&id=c6f97c1a"
import script from "./investPlantCalculator.vue?vue&type=script&lang=js"
export * from "./investPlantCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports